import { Whatsapp } from "@/assets";
import { useRegistrationProps } from "@/context/useRegistrationProps";
import { Toggle } from "@monsterindia/global-ui-components";
import React, { useState } from "react";

interface WhatsAppNotifyProps {
  updateToggle: (checked: boolean) => void;
}

const WhatsAppNotify: React.FC<WhatsAppNotifyProps> = ({ updateToggle }) => {
  const [isWhatsappChecked, setIsWhatsappChecked] = useState(true);
  const {
    translation: { socialLogin },
    handleEventTracking,
  } = useRegistrationProps();

  const handleToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setIsWhatsappChecked(checked);
    updateToggle(checked);
    handleEventTracking({
      eventType: "eventPush",
      eventName: "Registration_Filled",
      eventProps: { Whatsapp_Toggle_Status: checked },
    });
  };

  return (
    <div className="flex items-center gap-2 rounded bg-white py-2">
      <Toggle
        size="small"
        id="isToggled"
        toggleSize="small"
        checked={isWhatsappChecked}
        onChange={handleToggleChange}
      />
      <p className="text-content-primary flex items-center gap-1 text-xs">
        {socialLogin.receiveNotifications} <Whatsapp height={16} width={16} />
        {socialLogin.whatsapp}
      </p>
    </div>
  );
};

export default WhatsAppNotify;
